<template>
  <v-app>
    <v-toolbar color="secondary" app>
      <img src="/static/logo.png" style="height: 50%; margin-left: 1%" />
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content app>
      <v-layout row wrap>
        <v-flex xs1 md3></v-flex>
        <v-flex xs10 md6>
          <v-form v-model="valid" align-center="true" @submit.prevent="login">
            <v-text-field v-model="username" label="Username (admin)" required></v-text-field>
            <v-text-field
              v-model="password"
              :type="show_password ? 'text' : 'password'"
              label="Password"
              :append-icon="show_password ? 'visibility_off' : 'visibility'"
              required
              @click:append="show_password = !show_password"
            ></v-text-field>
            <p style="color: red" name="error-message">{{ loginmessage }}</p>
            <v-btn
              :disabled="username == '' || password == ''"
              type="submit"
              color="primary"
              class="black--text"
              name="login-button"
            >
              <div v-if="!login_button_loading">Login</div>
              <v-progress-circular v-if="login_button_loading" pl-5 size="25" indeterminate></v-progress-circular
            ></v-btn>
          </v-form>
        </v-flex>
        <v-flex xs1 md3> </v-flex>
      </v-layout>
    </v-content>
    <v-footer color="secondary" app>
      <v-spacer></v-spacer>
      <div style="color: #00b09b">&copy; Exasol Cloud UI {{ new Date().getFullYear() }}</div>
      <v-spacer></v-spacer>
    </v-footer>
  </v-app>
</template>

<script>
import xmlrpcservice from '@/service/xmlrpc-service';
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Login',
  data() {
    return {
      valid: false,
      username: 'admin',
      password: '',
      ip_address: '',
      title: null,
      loginmessage: null,
      show_password: false,
      xmlrpcservice: xmlrpcservice,
      login_button_loading: false,
    };
  },
  methods: {
    login: function () {
      localStorage.proxyURL = location.origin;
      localStorage.ip_address = 'localhost';
      localStorage.pluginVersion = `Cloud.UIBackend-${this.version}`;
      this.login_button_loading = true;
      localStorage.credentials = 'Basic ' + new Buffer(this.username + ':' + this.password).toString('base64');
      this.xmlrpcservice.callNativeXMLRPCRoutine('showPluginList', '', (loginSuccessful, message) => {
        this.login_button_loading = false;
        localStorage.is_logged_in = true;
        if (loginSuccessful == null) {
          try {
            if (message.message == 'Failed to fetch') {
              this.loginmessage = 'Cluster service not available';
            } else if (message.faultString.startsWith('Unauthorized')) {
              this.loginmessage = 'Unauthorized: wrong credentials';
            } else {
              this.loginmessage = 'Login failed';
            }
          } catch (e) {
            this.loginmessage = 'Login failed';
          }
        } else if (loginSuccessful.includes(localStorage.pluginVersion)) {
          localStorage.is_logged_in = true;
          this.$router.push('/home');
        } else {
          this.loginmessage = `Your plugin version of the Cloud UI Backend (${
            loginSuccessful.filter((x) => x.includes('Cloud.UIBackend'))[0]
          }) is outdated and cannot be used with the current Cloud UI, please upgrade to version ${
            localStorage.pluginVersion
          }`;
        }
      });
    },
  },
};
</script>

<style scoped></style>
